<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <HrTree @nodeClick="onHrTree"></HrTree>
    </div>
    <div class="d-flex-right">
      <div>
        <div>
          <el-descriptions size="mini" :column="1" border direction="vertical">
            <el-descriptions-item label="检索">
              <div>
                <el-descriptions size="mini" :label-style="{width: '80px'}" :column="3" border>
                  <el-descriptions-item label="统计周期">
                    <el-date-picker
                      v-model="where.month_db"
                      class="where-item"
                      type="month"
                      size="mini"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="选择月份表" :picker-options="forbiddenStartTime">
                    </el-date-picker>
                  </el-descriptions-item>
                  <el-descriptions-item label="查询时间">
                    <el-date-picker
                      v-model="where.start_time"
                      class="where-item"
                      type="date"
                      size="mini"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                    -
                    <el-date-picker
                      v-model="where.end_time"
                      class="where-item"
                      type="date"
                      size="mini"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-descriptions-item>
                  <el-descriptions-item label="HOST">
                    <el-select size="mini" class="where-item" v-model="where.host" clearable filterable placeholder="host">
                      <el-option v-for="(item,index) in where_obj.host_list" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item label="路由">
                    <el-select size="mini" class="where-item" v-model="where.path" clearable filterable placeholder="路由">
                      <el-option v-for="(item,index) in where_obj.path_list" :key="index" :label="item.title" :value="item.path"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item label="部门">
                    <el-input v-model="where.ancestor_name" clearable size="mini" class="where-item" placeholder="部门"></el-input>
                  </el-descriptions-item>
                  <el-descriptions-item label="职位">
                    <el-select size="mini" class="where-item" v-model="where.position_id" clearable filterable placeholder="职位">
                      <el-option v-for="(item,index) in where_obj.position_list" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item label="停留时长">
                    <el-select size="mini" class="where-item" v-model="where.duration_time" clearable filterable placeholder="停留时长">
                      <el-option v-for="(item,index) in where_obj.duration_list" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item label="组">
                    <el-select size="mini" class="where-item" v-model="where.group_name" clearable filterable placeholder="组">
                      <el-option v-for="(item,index) in where_obj.group_list" :key="index" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-descriptions-item>
                  <el-descriptions-item label="姓名">
                    <el-input v-model="where.user_name" clearable size="mini" class="where-item" placeholder="姓名"></el-input>
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            :data="pageData.list"
            border
            style="width: 100%">
            <el-table-column
              prop="id"
              label="ID"
              width="80">
            </el-table-column>
            <el-table-column
              prop="user_name"
              label="姓名"
              width="100">
            </el-table-column>
            <el-table-column
              prop="position_name"
              label="职位"
              width="150">
            </el-table-column>
            <el-table-column
              prop="department_name"
              label="部门"
              width="150">
            </el-table-column>
            <el-table-column
              prop="module_name"
              label="模块"
              width="100">
            </el-table-column>
            <el-table-column
              prop="path"
              label="路由"
              width="180">
            </el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              width="100">
            </el-table-column>
            <el-table-column
              prop="url"
              label="URL"
              width="110">
              <template slot-scope="scope">
                <el-tooltip effect="dark" :content="scope.row.url" placement="bottom">
                  <span class="row-item">{{scope.row.url}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="start_time"
              label="开始时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="end_time"
              label="离开时间"
              width="150">
            </el-table-column>
            <el-table-column
              prop="duration_time"
              label="停留时长（秒）"
              width="100">
            </el-table-column>
            <el-table-column
              prop="host"
              label="HOST"
              width="180">
            </el-table-column>
            <el-table-column
              prop="client_ip"
              label="IP"
              width="150">
            </el-table-column>
            <el-table-column
              prop="user_agent"
              label="user_agent"
              width="150">
              <template slot-scope="scope">
                <el-tooltip effect="dark" :content="scope.row.user_agent" placement="bottom">
                  <span class="row-item">{{scope.row.user_agent}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="group_name"
              label="组"
              width="150">
            </el-table-column>
            <el-table-column
              prop="group_key"
              label="键"
              width="150">
            </el-table-column>
            <el-table-column
              prop="group_val"
              label="值"
              width="150">
            </el-table-column>
            <el-table-column
              prop="remarks"
              label="备注"
              width="150">
              <template slot-scope="scope">
                <el-tooltip effect="dark" :content="scope.row.remarks" placement="bottom">
                  <span class="row-item">{{scope.row.remarks}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="添加时间"
              width="150">
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HrTree from "../Personnel/components/HrTree";
import moment from "moment/moment";
import Http from "./common/Http";
export default {
  name: "LogList",
  components: {HrTree},
  data() {
    return {
      loading: false,
      where_obj: {
        host_list: [],
        path_list: [],
        position_list: [],
        duration_list: [],
        group_list: []
      },
      where: {
        text: "",
        user_name: "",
        month_db: moment(new Date()).format("YYYY-MM"),
        start_time: moment(new Date()).format("YYYY-MM-DD"),
        end_time: moment(new Date()).format("YYYY-MM-DD"),
        host: "",
        path: "",
        department_id:"",
        ancestor_name:"",
        position_id: "",
        duration_time: "",
        group_name: ""
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      forbiddenStartTime: {
        disabledDate: this.disabledDateMethod,
      },
    }
  },
  mounted() {
    this.getGroupObj();
    this.pageChange();
  },
  methods: {
    disabledDateMethod(time) {
      let month_time = moment(time).format("YYYYMM");
      let start_month_time = 202308;
      let end_month_time = moment(new Date()).format("YYYYMM");
      return !(month_time >= start_month_time && month_time <= end_month_time);
    },
    onHrTree(data) {
      console.log(data)
      const that = this;
      that.where.ancestor_name = data.ancestor_name;
      that.where.department_id = data.id;
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = {
        ...that.where,
      }
      // 请求
      Http.post('logger/index/getList', {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        that.loading = false;
        if (res.code) {
          that.pageData = res.data;
        }
      })
    },
    getGroupObj() {
      const that = this;
      Http.post('logger/index/getGroupObj', {month_db: that.where.month_db}, res => {
        if (res.code) {
          that.where_obj.host_list = (res.data||{}).host_list||[];
          that.where_obj.path_list = (res.data||{}).path_list||[];
          that.where_obj.position_list = (res.data||{}).position_list||[];
          that.where_obj.duration_list = (res.data||{}).duration_list||[];
          that.where_obj.group_list = (res.data||{}).group_list||[];
        }
      })
    }
  },
  watch: {
    "where.month_db": function (n, o) {
      this.getGroupObj();
      this.pageChange(1);
    },
    "where.start_time": function (n, o) {
      this.pageChange(1);
    },
    "where.end_time": function (n, o) {
      this.pageChange(1);
    },
    "where.host": function (n, o) {
      this.pageChange(1);
    },
    "where.path": function (n, o) {
      this.pageChange(1);
    },
    "where.position_id": function (n, o) {
      this.pageChange(1);
    },
    "where.duration_time": function (n, o) {
      this.pageChange(1);
    },
    "where.group_name": function (n, o) {
      this.pageChange(1);
    },
    "where.user_name": function (n, o) {
      this.pageChange(1);
    },
    "where.department_id": function (n, o) {
      this.pageChange(1);
    },
    "where.ancestor_name": function (n, o) {
      if(!n) this.where.department_id="";
    },
  },
}

</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger, .el-button--success, .el-button--warning {
  color: #fff;
}

.row-item{
  width: 100px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.where-item{
  width: 200px;
}
.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
}
.amap-box{
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Log/LogList.vue